import { forwardRef } from 'react'
import { screenContainer } from './screenContainer.css'

interface ScreenContainerProps {
  children: JSX.Element
}

const ScreenContainer = forwardRef<HTMLDivElement, ScreenContainerProps>(
  ({ children }: ScreenContainerProps, ref) => {
    return (
      <div ref={ref} className={screenContainer}>
        {children}
      </div>
    )
  }
)

ScreenContainer.displayName = 'ScreenContainer'

export default ScreenContainer
